enum PayableDetailsActionType {
    PAYABLE_DETAILS_REQUEST_DATA = "PAYABLE_DETAILS_REQUEST_DATA",
    PAYABLE_DETAILS_HIDE_SPINNER = "PAYABLE_DETAILS_HIDE_SPINNER",
    PAYABLE_DETAILS_DISPLAY_ERROR = "PAYABLE_DETAILS_DISPLAY_ERROR",
}

export default PayableDetailsActionType;